/***
 * 
 * Price Update Collection Pages - Product Card
 * 
 */

document.addEventListener(`${window.eight.constants.events["ARMADA:VARIANT:CHANGE"]}`, (e) => {
    const { productId, variant } = e.detail;

    const productCards = document.querySelectorAll(`[data-sh-product-id="${productId}"]`)
    if (productCards.length === 0) return

    productCards.forEach(card => {
        const regularPrice = card.querySelector(`[data-aid="regular-price"]`);
        const compareAt = card.querySelector(`[data-aid="compare-at-price"]`);
        const compareAtWrap = card.querySelector(`[data-armada-selector="compare-at-container"]`);
        
        regularPrice.innerText = window.eight.productEngine.formatMoney(variant.price, this.moneyFormat);

        if (variant.compare_at_price === null) {
            compareAt.innerText = '';
            compareAtWrap.classList.add('hidden');
        } else {
            compareAt.innerText = window.eight.productEngine.formatMoney(variant.compare_at_price, this.moneyFormat);
            compareAtWrap.classList.remove('hidden');
        }

    });
    
});


/***
 * 
 * Single Variant ATC
 * 
 */

document.addEventListener('click', e => {
    const button = e.target 
    if (button.dataset.name === undefined) return 
    if (!button.dataset.name.includes("sh-quick-add-add-to-cart")) return

    const text = button.innerHTML
    button.style.removeProperty("opacity")

    const resetButtonAfterAdd = () => {
        button.disabled = true

        setTimeout(() => {
            button.disabled = false
            button.innerHTML = text
            button.style.opacity = 1
        }, window.eight.product.addedTimeout);
    }

    const atcSuccess = () => {
        button.innerHTML = 'Added'
        resetButtonAfterAdd()
    }

    const atcError = () => {
        console.warn('Quick add error', data)
        resetButtonAfterAdd()
    }

    const inputSelector = button.closest('[data-aid="product-card"]').querySelector('[data-quantity-input]')
    const variantId = +button.dataset.defaultVariantId
    
    let quantityValue = 1
    
    if (inputSelector !== null) {
      quantityValue = +inputSelector.value
    }

    const formData = {
        items: [
          {
            id: variantId,
            quantity: quantityValue,
          },
        ],
    };
    
    window.eight.cartEngine.addToCart(
        formData,
        'items',
        atcSuccess,
        atcError
    );
})